<template>
  <CountryPage country="vietnam" />
</template>